import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Switch, Button, Card } from "antd";
import { handleApiSuccess, handleApiError } from "utils";
import {
  billingCategoryByIdService,
  billingCategoryCreateService,
  billingCategoryUpdateService,
} from "services/billing";

export default function CategoryForm({ id }) {
  const history = useHistory();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (id) {
      billingCategoryByIdService(id)
        .then((response) => {
          if (response.data.item) form.setFieldsValue(response.data.item);
        })
        .catch((error) => handleApiError(error));
    } else {
      form.setFieldsValue({ is_active: true });
    }
  }, [id, form]);

  const onFinish = (values) => {
    setIsLoading(true);
    const action = id
      ? billingCategoryUpdateService(id, values)
      : billingCategoryCreateService(values);
    action
      .then((response) => {
        setIsLoading(false);
        handleApiSuccess(response);
        history.push("/billing/categories");
      })
      .catch((error) => {
        setIsLoading(false);
        handleApiError(error);
      });
  };

  return (
    <Card style={{ maxWidth: 560 }}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder="e.g. Phones, Tech Support, Websites, Parts" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={3} />
        </Form.Item>
        <Form.Item label="Active" name="is_active" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          {id ? "Update" : "Create"}
        </Button>
      </Form>
    </Card>
  );
}
